import React, { useEffect, useState } from "react";

const StatisticCard = ({
  title,
  value,
  equivalent,
  icon,
  bgcolor,
  gif,
  segundaParte,
  decimal = false,
}) => {
  const [displayedValue, setDisplayedValue] = useState("0");
  const [displayedEquivalent, setDisplayedEquivalent] = useState("0");

  const parsePtBRNumber = (value) => {
    return parseFloat(value.replace(/\./g, "").replace(",", "."));
  };

  const getDecimalPlaces = (value) => {
    if (!value.includes(",")) return 0;
    return value.split(",")[1].length;
  };

  const formatNumber = (number, decimals) => {
    return number.toLocaleString("pt-BR", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  useEffect(() => {
    const updateValues = () => {
      const valueToReach = parsePtBRNumber(value);
      const equivalentToReach = parsePtBRNumber(equivalent);

      const valueDecimals = decimal ? getDecimalPlaces(value) : 0;
      const equivalentDecimals = decimal ? getDecimalPlaces(equivalent) : 0;

      const steps = 100;
      const increment = valueToReach / steps;
      const equivalentIncrement = equivalentToReach / steps;

      let currentValue = 0;
      let currentEquivalent = 0;

      const interval = setInterval(() => {
        currentValue += increment;
        currentEquivalent += equivalentIncrement;

        if (currentValue >= valueToReach) {
          setDisplayedValue(formatNumber(valueToReach, valueDecimals));
          setDisplayedEquivalent(
            formatNumber(equivalentToReach, equivalentDecimals)
          );
          clearInterval(interval);
        } else {
          setDisplayedValue(formatNumber(currentValue, valueDecimals));
          setDisplayedEquivalent(
            formatNumber(currentEquivalent, equivalentDecimals)
          );
        }
      }, 50);

      return () => clearInterval(interval);
    };

    updateValues();
    const loopInterval = setInterval(updateValues, 10000);

    return () => clearInterval(loopInterval);
  }, [value, equivalent, decimal]);

  return (
    <div className="relative bg-white p-6 rounded-[40px] shadow-md flex flex-col items-center w-[54%]">
      <div
        className={`relative -top-28 w-52 h-52 md:w-52 md:h-52 rounded-full flex items-center justify-center bg-${bgcolor}`}
      >
        <img src={gif} alt={title} />
      </div>
      <div className="text-center -top-14 position-inherit">
        <p className="text-3xl font-bold text-gray-800">{displayedValue}</p>
        <p className="text-xl text-gray-600">{title}</p>
        <div className="flex flex-row">
          <p className="mt-4 text-lg text-orange-600 text-left">
            Equivalente a{" "}
            <span
              className="font-bold"
              dangerouslySetInnerHTML={{ __html: `${displayedEquivalent}` }}
            />{" "}
            {segundaParte}
          </p>
        </div>
      </div>
      <div className="bg-eithnary w-20 h-20 custom-rounded relative top-14 left-20 flex items-center justify-center text-white">
        {icon}
      </div>
    </div>
  );
};

export default StatisticCard;
